import React, { useState, useEffect } from 'react'
import SubHeader from '../../layout/components/SubHeader'
import { useNavigate } from 'react-router-dom'
import {toAbsoluteUrl} from '../../helpers/AssetHelpers'
import campaignService from '../../../services/campaign.service'
import { useEyeconxStore } from '../../../store/eyeconxStore'

function SmsNewsletter() {
    const navigate = useNavigate()
    const clinicId = useEyeconxStore((state) => state.user.clinicId)
    const [campaigns, setCampaigns] = useState([])
    const [loading, setLoading] = useState(true)
    const [page, setPage] = useState(0)
    const [size, setSize] = useState(10)
    const [totalElements, setTotalElements] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [statusFilter, setStatusFilter] = useState('')

    const handleCreateNewCampaign = () => {
        navigate('/newsletter/create-sms')
    }

    const fetchCampaigns = async (currentPage = page, currentSize = size, currentStatus = statusFilter) => {
        try {
            setLoading(true)
            const params = {
                type: 'SMS',
                category: 'NEWSLETTER',
                page: currentPage,
                size: currentSize
            }
            if (currentStatus) {
                params.status = currentStatus
            }
            const response = await campaignService.getCampaigns(clinicId, params)
            setCampaigns(response.data.content || [])
            setTotalElements(response.data.totalElements || 0)
            setTotalPages(response.data.totalPages || 0)
        } catch (error) {
            console.error('Error fetching campaigns:', error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (clinicId) {
            fetchCampaigns()
        } else {
            setLoading(false)
        }
    }, [clinicId])

    const handlePageChange = (newPage) => {
        setPage(newPage)
        fetchCampaigns(newPage, size, statusFilter)
    }

    const handleSizeChange = (newSize) => {
        setSize(newSize)
        setPage(0)
        fetchCampaigns(0, newSize, statusFilter)
    }

    const handleStatusFilterChange = (newStatus) => {
        setStatusFilter(newStatus)
        setPage(0)
        fetchCampaigns(0, size, newStatus)
    }

  return (
   <>
    <SubHeader title="SMS Newsletter" description={"SMS Newsletter Communication"} >
            <div className="d-flex justify-content-end">
                <button className="btn btn-light-primary btn-sm" onClick={handleCreateNewCampaign}>Create New Campaign</button>
            </div>
        </SubHeader>

    <div className="row">
        <div className="col-3">

            <img src={toAbsoluteUrl('/media/illustrations/ecx/personal_text_re_vqj3.svg')} className='img-fluid p-5' />

            <div className="alert bg-light-success d-flex flex-column flex-sm-row p-5 mb-10 mt-5">
        <span className="svg-icon svg-icon-2hx svg-icon-success me-4 mb-5 mb-sm-0">
            <svg xmlns="XXXXXXXXXXXXXXXXXXXXXXXXXX" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="currentColor"></rect>
                <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="currentColor"></rect>
            </svg>
        </span>
        <div className="d-flex flex-column text-success pe-0 pe-sm-10">
            <h4 className="mb-1">Please read</h4>
            <span>Use this SMS newsletter campaign to send regular updates and news to your patients. This campaign will send text messages to all the selected patients who have cell phone number and have subscribed to your newsletters. </span>
        </div>
    </div>
        </div>
        <div className="col-9">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-5">
                        <select 
                            className="form-select form-select-sm w-auto" 
                            value={statusFilter}
                            onChange={(e) => handleStatusFilterChange(e.target.value)}
                        >
                            <option value="">All Status</option>
                            <option value="PENDING">Pending</option>
                            <option value="COMPLETED">Completed</option>
                            <option value="ERROR">Error</option>
                        </select>
                        <span className="text-muted">Total: {totalElements}</span>
                    </div>
                {loading ? (
                    <div className="text-center py-10">Loading...</div>
                ) : (
                    <>
                    <table className="table table-striped gy-7">
                        <thead>
                            <tr className='fw-bolder fs-6 text-gray-800'>
                            <th>Campaign</th>
                            <th>Created</th>
                            <th>Status</th>
                            <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {campaigns.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="text-center">No campaigns found</td>
                                </tr>
                            ) : (
                                campaigns.map((campaign) => (
                                    <tr key={campaign.id}>
                                        <td>
                                            <div className="d-flex flex-column ps-4">
                                                <div className="text-dark text-hover-primary mb-1 fs-6">{campaign.name}</div>
                                                <div className="text-muted fw-bold fs-7">{campaign.description || ''}</div>
                                            </div>
                                        </td>
                                        <td>{campaign.createdAt || '-'}</td>
                                        <td><span className={`badge badge-${campaign.status === 'COMPLETED' ? 'success' : campaign.status === 'PENDING' ? 'info' : 'danger'}`}>{campaign.status}</span></td>
                                        <td> <button className="btn btn-sm btn-secondary">More </button> </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                    {totalPages > 1 && (
                        <div className="d-flex justify-content-between align-items-center mt-5">
                            <div className="d-flex align-items-center">
                                <span className="me-2">Show</span>
                                <select 
                                    className="form-select form-select-sm w-auto" 
                                    value={size}
                                    onChange={(e) => handleSizeChange(parseInt(e.target.value))}
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>
                            </div>
                            <nav>
                                <ul className="pagination pagination-sm mb-0">
                                    <li className={`page-item ${page === 0 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(page - 1)} disabled={page === 0}>Previous</button>
                                    </li>
                                    {[...Array(totalPages)].map((_, i) => (
                                        <li key={i} className={`page-item ${page === i ? 'active' : ''}`}>
                                            <button className="page-link" onClick={() => handlePageChange(i)}>{i + 1}</button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${page === totalPages - 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(page + 1)} disabled={page === totalPages - 1}>Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    )}
                    </>
                )}
                </div>
            </div>
        </div>
    </div>
   </>
  )
}

export default SmsNewsletter
